import createAction from 'redux-actions/lib/createAction';

export const SET_RECIPE_MODAL_OPEN = 'plannerActions/SET_RECIPE_MODAL_OPEN';
export const setRecipeModalOpen = createAction(SET_RECIPE_MODAL_OPEN);
